import { render, staticRenderFns } from "./SetupChoiceGrid.vue?vue&type=template&id=48b9eb49&scoped=true&"
import script from "./SetupChoiceGrid.vue?vue&type=script&lang=js&"
export * from "./SetupChoiceGrid.vue?vue&type=script&lang=js&"
import style0 from "./SetupChoiceGrid.vue?vue&type=style&index=0&id=48b9eb49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9eb49",
  null
  
)

export default component.exports